import { Fragment } from "react";
import { Modal } from "react-bootstrap";

export default function UseModal({
  heading,
  size,
  component,
  footer,
  isModalOpen,
  handlePopUp,
  className
}) {
  return (
    <Fragment>
      <Modal
        size={size}
        show={isModalOpen}
        onHide={() => handlePopUp(0, false)}
      >
        <Modal.Header closeButton>
          <div className={`${className ? className : 'claimNowDiv'}`}>
            <label className="Montserrat text-decoration-none">{heading}</label>
          </div>
        </Modal.Header>
        <Modal.Body>{component}</Modal.Body>
        {footer && <Modal.Footer>{footer}</Modal.Footer>}
      </Modal>
    </Fragment>
  );
}
